export const GENDERS = ["Mens", "Ladies", "Unisex"] as const;

export type Gender = (typeof GENDERS)[number];

const GENDER_ALIASES: { gender: Gender; match: (value: string) => boolean }[] = [
  {
    gender: "Unisex",
    match: (v) => v.includes("unisex") || v.includes("midsize"),
  },
  {
    gender: "Ladies",
    match: (v) =>
      v.includes("lad") || v.includes("women") || v.includes("female"),
  },
  {
    gender: "Mens",
    match: (v) =>
      v.includes("men") || v.includes("gent") || v.includes("male"),
  },
];

export function normalizeGender(value: string): Gender | "" {
  const normalized = value.trim().toLowerCase();
  if (!normalized) return "";
  return GENDER_ALIASES.find((a) => a.match(normalized))?.gender ?? "";
}

export function buildPassportName(fields: {
  brand: string;
  model: string;
  reference: string;
  dialColor: string;
  caseMaterial: string;
  gender: string;
}): string {
  const brand = fields.brand.trim();
  const model = fields.model.trim();
  if (!brand && !model) return "";

  const dialColor = fields.dialColor.trim();

  return [
    brand,
    model,
    fields.reference.trim(),
    dialColor ? `${dialColor} Dial` : "",
    fields.caseMaterial.trim(),
    fields.gender.trim(),
    "Watch",
  ]
    .filter(Boolean)
    .join(" ");
}
